<script lang="ts">
/**
 * 双色图标的图形表(24×24 的画框):a = 描线(必有),b = 一块浅色面(同色 20%),c = 一点强调色。
 * 都是路径(圆也写成路径),线宽和圆头在样式里统一给。要加图标就在这里加一行。
 */
const circle = (cx: number, cy: number, r: number) =>
  `M${cx - r} ${cy}a${r} ${r} 0 1 0 ${r * 2} 0a${r} ${r} 0 1 0 ${-r * 2} 0z`;

export const DUO_ICONS = {
  // ── 平台能力 ──
  trophy: {
    a: 'M7 4h10v6a5 5 0 0 1-10 0zM7 6H4v1.5A3.5 3.5 0 0 0 7.5 11M17 6h3v1.5a3.500 3.500 0 0 1-3.500 3.500M12 15v4M8.5 20h7',
    b: 'M7 4h10v6a5 5 0 0 1-10 0z',
  },
  users: {
    a: `${circle(9, 8, 3.4)}M3 20a6 6 0 0 1 12 0M16.5 5a3.3 3.3 0 0 1 0 6.3M18 14.6A6 6 0 0 1 21 20`,
    b: circle(9, 8, 3.4),
  },
  family: {
    a: 'M4 11l8-7 8 7v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z',
    b: 'M4 11l8-7 8 7v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z',
    c: 'M12 17.6c-2-1.4-3-2.6-3-3.9a1.7 1.7 0 0 1 3-1 1.7 1.7 0 0 1 3 1c0 1.3-1 2.5-3 3.9z',
  },
  network: {
    a: `M12 8v4M12 12l-5.2 3.500M12 12l5.200 3.500${circle(12, 5.5, 2.5)}${circle(5, 17.5, 2.5)}${circle(19, 17.5, 2.5)}`,
    b: circle(12, 5.5, 2.5),
  },
  shield: {
    a: 'M12 3l7.500 3v5.500c0 4.400-3 7.600-7.500 9.500-4.500-1.900-7.500-5.100-7.500-9.500V6zM8.800 12l2.300 2.300 4.200-4.400',
    b: 'M12 3l7.500 3v5.500c0 4.400-3 7.600-7.500 9.500-4.500-1.900-7.500-5.100-7.500-9.500V6z',
  },
  // ── 产品一览 ──
  map: {
    a: 'M3 6.500l6-2.500 6 2.500 6-2.500v13.500l-6 2.500-6-2.500-6 2.500zM9 4v13.500M15 6.500V20',
    b: 'M9 4l6 2.500V20l-6-2.500z',
  },
  lesson: {
    a: 'M5 4.500h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zM10.200 8.300v5.400l4.600-2.700zM8 20.500h8',
    b: 'M5 4.500h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z',
  },
  star: {
    a: 'M12 3.500l2.600 5.300 5.900.900-4.200 4.100 1 5.800L12 16.900l-5.300 2.700 1-5.800-4.200-4.100 5.900-.900z',
    b: 'M12 3.500l2.600 5.300 5.900.900-4.200 4.100 1 5.800L12 16.900l-5.300 2.700 1-5.800-4.200-4.100 5.900-.900z',
  },
  exam: {
    a: 'M9 3.500h6v3H9zM9 5H7a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2M9 13.200l2.100 2.100 3.900-4.300',
    b: 'M6 5h12v15H6z',
  },
  phone: {
    a: 'M9 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM11 17.800h2',
    b: 'M9 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z',
  },
  report: {
    a: 'M6 3.500h12a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1zM9 16.500v-3M12 16.500V8.500M15 16.500v-5.500',
    b: 'M6 3.500h12a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1z',
  },
  // ── 认证与竞赛 ──
  target: {
    a: `${circle(12, 12, 8.5)}${circle(12, 12, 4.6)}`,
    b: circle(12, 12, 8.5),
    c: circle(12, 12, 1.7),
  },
  medal: {
    a: `${circle(12, 9, 5.5)}M8.700 13.400L7.200 21l4.800-2.600 4.800 2.600-1.500-7.600`,
    b: circle(12, 9, 5.5),
    c: circle(12, 9, 1.9),
  },
  flag: {
    a: 'M5.500 21V4M5.500 4.500h11.300l-2.300 3.700 2.300 3.800H5.500',
    b: 'M5.500 4.500h11.300l-2.300 3.700 2.300 3.800H5.500z',
  },
  // ── 数字人伴学 ──
  heart: {
    a: 'M12 20s-7.500-4.300-7.500-10.200a4.200 4.200 0 0 1 7.500-2.600 4.200 4.200 0 0 1 7.500 2.600C19.500 15.700 12 20 12 20z',
    b: 'M12 20s-7.500-4.300-7.500-10.200a4.200 4.200 0 0 1 7.500-2.600 4.200 4.200 0 0 1 7.500 2.600C19.500 15.700 12 20 12 20z',
  },
  bulb: {
    a: 'M9.500 17.500h5M10.300 20.500h3.400M8.600 14.300a6 6 0 1 1 6.800 0c-.600.500-.900 1.100-.900 1.900v1.300h-5v-1.300c0-.800-.300-1.400-.900-1.900z',
    b: 'M8.600 14.300a6 6 0 1 1 6.800 0c-.600.500-.900 1.100-.900 1.900v1.300h-5v-1.300c0-.800-.300-1.400-.900-1.900z',
  },
  rocket: {
    a: 'M12 3c3 2.200 4.500 5.300 4.500 8.700 0 1.700-.400 3.200-1 4.300h-7c-.600-1.100-1-2.600-1-4.300C7.500 8.300 9 5.200 12 3zM8.300 14.500L5.500 17l.700 3 2.600-1.800M15.700 14.500l2.800 2.500-.700 3-2.600-1.800M12 16v4.500',
    b: 'M12 3c3 2.200 4.500 5.300 4.500 8.700 0 1.700-.400 3.200-1 4.300h-7c-.600-1.100-1-2.600-1-4.300C7.500 8.300 9 5.200 12 3z',
    c: circle(12, 9.5, 1.7),
  },
  // ── 官网内页(2026-10-13 第二轮) ──
  pencil: {
    a: 'M5 19l.9-4.2L16 4.700l3.300 3.300L9.200 18.100zM14 6.700l3.300 3.300M13.500 19.500h6',
    b: 'M5 19l.9-4.2L16 4.700l3.300 3.300L9.200 18.100z',
  },
  school: {
    a: 'M5 20V6.500a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1V20M15 10.500h3a1 1 0 0 1 1 1V20M3.500 20h17M8 9h1.200M11 9h1.200M8 12.500h1.200M11 12.500h1.200M9 20v-3.500h2.200V20',
    b: 'M5 20V6.500a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1V20z',
  },
  layers: {
    a: 'M12 3.500l8.500 4.500L12 12.500 3.500 8zM3.500 12l8.500 4.500 8.500-4.500M3.500 16l8.500 4.500 8.500-4.500',
    b: 'M12 3.500l8.500 4.500L12 12.500 3.500 8z',
  },
  clock: {
    a: `${circle(12, 12, 8.5)}M12 7.500V12l3.200 2`,
    b: circle(12, 12, 8.5),
  },
  alert: {
    a: 'M12 4.500l8.500 15h-17zM12 10.200v4.300M12 17v.100',
    b: 'M12 4.500l8.500 15h-17z',
  },
  calendar: {
    a: 'M5 6h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM4 10.500h16M8.500 4v3.500M15.500 4v3.500',
    b: 'M4 10.500V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3.500z',
  },
  doc: {
    a: 'M7 3.500h7l4 4v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1zM14 3.500v4h4M9 12.500h6M9 16h6',
    b: 'M7 3.500h7l4 4v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1z',
  },
  lock: {
    a: 'M7 10.500h10a1.500 1.500 0 0 1 1.500 1.500v6.500a1.500 1.500 0 0 1-1.500 1.500H7a1.500 1.500 0 0 1-1.500-1.500V12a1.500 1.500 0 0 1 1.500-1.500zM8.500 10.500V8a3.500 3.500 0 0 1 7 0v2.500M12 14.200v2.300',
    b: 'M7 10.500h10a1.500 1.500 0 0 1 1.500 1.500v6.500a1.500 1.500 0 0 1-1.500 1.500H7a1.500 1.500 0 0 1-1.500-1.500V12a1.500 1.500 0 0 1 1.500-1.500z',
  },
  // ── 聚焦页(2026-10-14 第三轮:登录与入口页、招生公开页) ──
  desktop: {
    a: 'M4 4.500h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1zM12 16.500v3.500M8 20h8',
    b: 'M4 4.500h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1z',
  },
  pin: {
    a: `M12 21s-6.500-5.700-6.500-10.700a6.500 6.500 0 0 1 13 0C18.500 15.300 12 21 12 21z${circle(12, 10.3, 2.4)}`,
    b: 'M12 21s-6.500-5.700-6.500-10.700a6.500 6.500 0 0 1 13 0C18.500 15.300 12 21 12 21z',
  },
  gift: {
    a: 'M5 11h14v8.500a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zM3.500 7.500h17V11h-17zM12 7.500v13M12 7.500C10.800 5 9.400 3.800 8 4.200c-1.500.400-1.700 2.400-.300 3.300M12 7.500c1.200-2.500 2.600-3.700 4-3.300 1.500.400 1.700 2.400.300 3.300',
    b: 'M3.500 7.500h17V11h-17z',
  },
  chat: {
    a: 'M5 4.500h14a1.500 1.500 0 0 1 1.500 1.500v9a1.500 1.500 0 0 1-1.500 1.500h-6.300L8 20.500v-4H5A1.500 1.500 0 0 1 3.500 15V6A1.500 1.500 0 0 1 5 4.500zM8.500 9h7M8.500 12.300h4.500',
    b: 'M5 4.500h14a1.500 1.500 0 0 1 1.500 1.500v9a1.500 1.500 0 0 1-1.500 1.500h-6.300L8 20.500v-4H5A1.500 1.500 0 0 1 3.500 15V6A1.500 1.500 0 0 1 5 4.500z',
  },
  call: {
    a: 'M6.300 4h3l1.500 4-2 1.300a11 11 0 0 0 5.900 5.900l1.300-2 4 1.500v3a1.800 1.800 0 0 1-1.900 1.800C10.600 19 5 13.400 4.500 5.900A1.800 1.800 0 0 1 6.300 4z',
    b: 'M6.300 4h3l1.500 4-2 1.300a11 11 0 0 0 5.900 5.900l1.300-2 4 1.500v3a1.800 1.800 0 0 1-1.900 1.800C10.600 19 5 13.400 4.500 5.900A1.800 1.800 0 0 1 6.300 4z',
  },
  // ── 小件 ──
  download: { a: 'M12 4.500v10.500M7.800 11l4.200 4.200 4.200-4.200M5 19.500h14' },
  /** 上传(2026-10-19 作品提交页加):托盘 + 往上的箭头 */
  upload: {
    a: 'M12 14.500V4M7.800 8.200L12 4l4.200 4.200M4 13.500v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5',
    b: 'M4 13.500h16v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z',
  },
  cross: { a: 'M7.500 7.500l9 9M16.500 7.500l-9 9' },
  check: { a: 'M5.500 12.500l4.300 4.300L18.500 7.800' },
  menu: { a: 'M4.500 7.500h15M4.500 12h15M4.500 16.500h15' },
} as const satisfies Record<string, { a: string; b?: string; c?: string }>;

export type DuoIconName = keyof typeof DUO_ICONS;
</script>

<script setup lang="ts">
import { computed } from 'vue';

/**
 * 双色图标(「精修做工」):线(currentColor)+ 一块浅色面(同色 20%)+ 可选的一点强调色。
 * 对外页面的要点、卡片上用,通常放在 .ptl-ico 图标块里(块的字色就是图标的颜色);
 * 通用的细线图标(Icon.vue)留给后台和工具条。装饰性,不进无障碍树。
 */
const props = defineProps<{ name: DuoIconName; size?: number }>();
const g = computed<{ a: string; b?: string; c?: string }>(() => DUO_ICONS[props.name]);
</script>

<template>
  <svg
    class="duo"
    :width="size ?? 26"
    :height="size ?? 26"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path v-if="g.b" class="duo-b" :d="g.b" />
    <path class="duo-a" :d="g.a" />
    <path v-if="g.c" class="duo-c" :d="g.c" />
  </svg>
</template>

<style scoped>
.duo {
  flex: none;
  display: block;
  overflow: visible;
}
.duo-a {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.duo-b {
  fill: color-mix(in srgb, currentColor 20%, transparent);
}
.duo-c {
  fill: var(--accent);
}
</style>
